import qs from 'qs';

export const state = () => ({
	applicant: null,
	job_application: null,
	filters: null,
	strength: null,
	favourite: null,
	viewed: null,
	status: null,
	order: {
		order_by: 'created_at',
		order_dir: 'desc',
	},
	search: null,
	applicants: null,
	answers: null,
	interviews: null,
});

export const mutations = {
	setApplicant(state: any, payload: any) {
		state.applicant = payload;
	},

	setJobApplication(state: any, payload: any) {
		state.job_application = payload;
	},

	setApplicants(state: any, payload: any) {
		state.applicants = payload;
	},

	setAnswers(state: any, payload: any) {
		state.answers = payload;
	},
	setInterviews(state: any, payload: any) {
		state.interviews = payload;
	},

	updateApplicants(state: any, payload: any) {
		if (!state.applicants) return;

		state.applicants.data.map(function (applicant) {
			if (applicant.uuid === payload.uuid) {
				Object.assign(applicant, payload);
			}
			return applicant;
		});
	},

	updateApplicantFavouriteStatus(state: any, payload: any) {
		return (state.applicant.favourite = payload.favourite);
	},

	setApplicantProspectUuid(state: any, payload: string) {
		if (!state.applicant) return;

		return (state.applicant.prospect_uuid = payload);
	},

	setFilters(state: any, payload: any) {
		state.filters = payload;
	},

	setStrength(state: any, payload: any) {
		state.strength = payload;
	},

	setFavourite(state: any, payload: any) {
		state.favourite = payload;
	},

	setViewed(state: any, payload: any) {
		state.viewed = payload;
	},

	setStatus(state: any, payload: any) {
		state.status = payload;
	},

	setOrder(state: any, payload: any) {
		state.order = payload;
	},

	setSearch(state: any, payload: any) {
		state.search = payload;
	},
};

export const getters = {
	getApplicant: (state: any) => state.applicant,

	getJobApplication: (state: any) => state.job_application,

	getApplicants: (state: any) => state.applicants,

	getAnswers: (state: any) => state.answers,

	getInterviews: (state: any) => state.interviews,

	getFilters: (state: any) => state.filters,

	getStrength: (state: any) => state.strength,

	getFavourite: (state: any) => state.favourite,

	getViewed: (state: any) => state.viewed,

	getStatus: (state: any) => state.status,

	getOrder: (state: any) => state.order,

	getSearch: (state: any) => state.search,
};

export const actions = {
	getCompanyApplications(state: any, payload: any) {
		const company = state.rootState.auth.user.company.uuid;
		const url = payload?.url || `/api/company/${company}/applications`;

		let status = state.state.status
			?.split('-')
			.map((item) => item.charAt(0).toUpperCase() + item.substring(1).toLowerCase())
			.join('');

		let data = { ...payload.data };

		state.state.favourite ? (data.favourite = state.state.favourite) : delete data.favourite;
		state.state.viewed ? (data.viewed = state.state.viewed) : delete data.viewed;
		state.state.status ? (data.status = status) : delete data.status;

		return new Promise((resolve, reject) => {
			this.$axios
				.get(url, {
					params: data,
				})
				.then((res) => {
					state.commit('setApplicants', res.data);
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	getJobApplications(state: any, payload: any) {
		const { jobUuid, ...data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.get(`/api/jobs/${jobUuid}/applications`, { params: data })
				.then((res) => {
					state.commit('setApplicants', res.data);
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	getJobApplication(state: any, applicationUuid: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get(`/api/jobs/applications/${applicationUuid}/`)
				.then((res) => {
					state.commit('setJobApplication', res.data);

					state.commit('jobs/single/setJobPost', res.data.job, {
						root: true,
					});

					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	updateApplication(state: any, payload: any) {
		const { applicationUuid, ...data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.put(`/api/jobs/applications/${applicationUuid}`, data)
				.then((res) => {
					state.commit('setJobApplication', { ...state.state.job_application, ...res.data });
					state.commit('updateApplicants', res.data);
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	rejectApplication(state: any, payload: any) {
		const { applicationUuid, ...data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.put(`/api/jobs/applications/${applicationUuid}/reject`, data)
				.then((res) => {
					state.commit('setJobApplication', { ...state.state.job_application, ...res.data });
					state.commit('updateApplicants', res.data);
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	getFullCandidateProfile(state: any, payload: any) {
		const { applicant_uuid, ...data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.get(`/api/candidate/profile/${applicant_uuid}`, { params: data })
				.then((res) => {
					this.$gtm.push({
						event: 'viewedFullProfile',
						job_id: payload.job_uuid,
						user_id: state.rootState.auth.user.uuid,
						company_id: state.rootState.auth.user.company.uuid,
						candidate_id: payload.applicant_uuid,
					});

					let applicants = JSON.parse(JSON.stringify(state.state.applicants));

					if (applicants) {
						applicants.data = applicants.data.map(function (applicant) {
							if (applicant.applicant_uuid === res.data.uuid) {
								applicant.profile_picture = res.data.profile_picture;
								applicant.initials = res.data.initials;
								applicant.display_name = `${res.data.name} ${res.data.surname}`;
								applicant.candidate_is_manually_verified = res.data.is_manually_verified;
							}

							// update the match strength if the job application is the same as the previewing application
							if (applicant.applicant_uuid === res.data.uuid && applicant.job.uuid === data.job_uuid) {
								applicant.match = res.data.match_overview?.strength;
							}

							return applicant;
						});

						state.commit('setApplicants', applicants);
					}

					state.commit('setApplicant', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getApplicationAnswers(state: any, jobApplicationUuid: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get(`api/jobs/applications/${jobApplicationUuid}/answers`)
				.then((res) => {
					state.commit('setAnswers', res.data);
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	getJobInterviews(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get(`api/jobs/${payload.uuid}/interviews`, {
					params: payload.params,
				})
				.then((res) => {
					state.commit('setInterviews', res.data);
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	recordCandidateProfileView(state: any, payload: any) {
		const company = state.rootState.auth.user.company.uuid;
		const url = `/api/company/${company}/profile-views`;

		return new Promise((resolve, reject) => {
			this.$axios
				.post(url, payload)
				.then((res) => resolve(res.data))
				.catch((err) => reject(err));
		});
	},

	toggleApplicationFavouriteStatus(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put(`/api/jobs/applications/${payload}/shortlist-toggle`)
				.then((res) => {
					state.commit('updateApplicants', res.data);
					state.commit('updateApplicantFavouriteStatus', res.data);
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	exportToExcel(state: any, payload: any) {
		const { job_uuid, ...filters } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.post(`/api/jobs/${job_uuid}/applications/export-to-excel`, filters, {
					responseType: 'blob',
					headers: {
						Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
					},
				})
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	setApplicant(state: any, payload: any) {
		state.commit('setApplicant', payload);
	},

	setJobApplication(state: any, payload: any) {
		state.commit('setJobApplication', payload);
	},

	setFilters(state: any, payload: any) {
		state.commit('setFilters', payload);
	},

	setStrength(state: any, payload: any) {
		state.commit('setStrength', payload);
	},

	setFavourite(state: any, payload: any) {
		state.commit('setFavourite', payload);
	},

	setViewed(state: any, payload: any) {
		state.commit('setViewed', payload);
	},

	setStatus(state: any, payload: any) {
		state.commit('setStatus', payload);
	},

	setOrder(state: any, payload: any) {
		state.commit('setOrder', payload);
	},

	setSearch(state: any, payload: any) {
		state.commit('setSearch', payload);
	},
};
